// jQuery(function ($) {
//     // const KEY = 'storage_cleared_once';

//     // if (!sessionStorage.getItem(KEY)) {

//     //     localStorage.clear();
//     //     sessionStorage.clear();

//     //     document.cookie.split(";").forEach(function (cookie) {
//     //         const name = cookie.split("=")[0].trim();
//     //         document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 UTC;path=/;";
//     //     });

//     //     sessionStorage.setItem(KEY, 'true');

//     // }
    
//     const $html = $('html');
//     const isEN = $html.attr('lang') === 'en';

//     // ===== EVENT =====
//     $(document).on(
//     "click",
//     ".grfq-page-products .grfq-product-duplicate, .grfq-variant-quantity-icon, .grfq-btn-add-group-product, .grfq-products-header-remove-btn",
//         updateTextTranslationsQuote
//     );

//     // ===== INIT =====
//     updateTextTranslationsQuote();

//     $(window).on("load", function () {
//         setTimeout(updateTextTranslationsQuote, 400);
//     });

//     // ===== MAIN FUNCTION =====
//     function updateTextTranslationsQuote() {

//         const $page = $('.rfq_form_page');

//         if (!$page.length) return; 

//         if (isEN) {

//             // ===== TEXT =====
//             $page.find('.grfq-form-header p').text('Request for form');
//             $page.find('.grfq-thankyou-subheading').text('Your quote is currently empty');

//             const $continue = $page.find('.grfq-continue-shopping a');
//             $continue.text('Continue shopping').attr('href', '/en/collections/all');

//             $page.find('#submitRFQForm').text('Submit');

//             $page.find('.grfq-group_name_text').text('Product');
//             $page.find('.grfq-group_edit-header .grfq-input-group input').val('Product');

//             // ===== INPUT =====
//             $page.find('#name').attr('placeholder', 'Enter your name');
//             $page.find('#email').attr('placeholder', 'Enter your email address');
//             $page.find('#phone__1724926594202').attr('placeholder', 'Phone number');
//             $page.find('#message').attr('placeholder', 'Message or question');

//             // ===== LABEL =====
//             $page.find('label[for="name"]').html('Name <span class="grfq-required-asterisk"> *</span>');
//             $page.find('label[for="phone__1724926594202"]').html('Phone <span class="grfq-required-asterisk"> *</span>');

//             // ===== VARIANT =====
//             $page.find('.grfq-variant-title[data-key="taille"]').each(function () {
//                 const $el = $(this);

//                 $el.attr('data-key', 'size');

//                 $el.find('.grfq-option-key').each(function (index) {
//                     if (index === 0 && $(this).text().toLowerCase().includes('taille')) {
//                         $(this).text('Size:');
//                     }
//                 });
//             });

//             $page.find('.grfq-variant-quantity-wrapper label').text('Quantity');
//             $page.find('.grfq-product-footer .grfq-continue-shopping a').text('Continue shopping');

//         } else {

//             setTimeout(function () {
//             $page.find('.grfq-collapsible-title').text('Infos supplémentaires');
//             $page.find('button.grfq-product-duplicate p').text('Article en double');

//             $('.grfq-page-products-add-group .grfq-btn-add-group-product span')
//                 .text('Créer un devis segmenté');
//             }, 600);

//             // ===== ADD GROUP =====
//             $page.find('.grfq-product-table .sami-empty-items p').text('Ce groupe de produits est actuellement vide');
//             $page.find('.grfq-product-table .sami-empty-items .grfq-continue-shopping .AddProductGroup').text('Ajouter des produits au groupe');
//             $page.find('.grfq-page-products-groups .grfq-product-table .grfq-product-footer .grfq-group_quick_add-search .grfq-group_quick_add-searchField .grfq-group_quick_add-searchField__Input').attr('placeholder', 'Rechercher un produit à ajouter');    
//         }
//     }
// });

jQuery(function ($) {

    const $html = $('html');
    const lang = ($html.attr('lang') || 'fr').toLowerCase().split('-')[0];

    const isEN = lang === 'en';
    const isDE = lang === 'de';
    const isFR = lang === 'fr';

    // ===== EVENT =====
    $(document).on(
        "click",
        ".grfq-page-products .grfq-product-duplicate, .grfq-variant-quantity-icon, .grfq-btn-add-group-product, .grfq-products-header-remove-btn",
        updateTextTranslationsQuote
    );

    // ===== INIT =====
    updateTextTranslationsQuote();

    $(window).on("load", function () {
        setTimeout(updateTextTranslationsQuote, 400);
    });

    // ===== MAIN FUNCTION =====
    function updateTextTranslationsQuote() {

        const $page = $('.rfq_form_page');

        if (!$page.length) return;

        // =====================================================
        // ENGLISH
        // =====================================================
        if (isEN) {

            // ===== TEXT =====
            $page.find('.grfq-form-header p').text('Request for form');
            $page.find('.grfq-thankyou-subheading').text('Your quote is currently empty');

            const $continue = $page.find('.grfq-continue-shopping a');

            $continue
                .text('Continue shopping')
                .attr('href', '/en/collections/all');

            $page.find('#submitRFQForm').text('Submit');

            $page.find('.grfq-group_name_text').text('Product');
            $page.find('.grfq-group_edit-header .grfq-input-group input').val('Product');

            // ===== INPUT =====
            $page.find('#name').attr('placeholder', 'Enter your name');
            $page.find('#email').attr('placeholder', 'Enter your email address');
            $page.find('#phone__1724926594202').attr('placeholder', 'Phone number');
            $page.find('#message').attr('placeholder', 'Message or question');

            // ===== LABEL =====
            $page.find('label[for="name"]')
                .html('Name <span class="grfq-required-asterisk"> *</span>');

            $page.find('label[for="phone__1724926594202"]')
                .html('Phone <span class="grfq-required-asterisk"> *</span>');

            // ===== VARIANT =====
            $page.find('.grfq-variant-title[data-key="taille"]').each(function () {

                const $el = $(this);

                $el.attr('data-key', 'size');

                $el.find('.grfq-option-key').each(function (index) {

                if (
                    index === 0 &&
                    $(this).text().toLowerCase().includes('taille')
                ) {
                    $(this).text('Size:');
                }

                });

            });

            $page.find('.grfq-variant-quantity-wrapper label')
                .text('Quantity');

            $page.find('.grfq-product-footer .grfq-continue-shopping a')
                .text('Continue shopping');

        }

        // =====================================================
        // GERMAN
        // =====================================================
        else if (isDE) {

            // ===== TEXT =====
            $page.find('.grfq-form-header p')
                .text('Anfrageformular');

            $page.find('.grfq-thankyou-subheading')
                .text('Ihre Anfrage ist derzeit leer');

            const $continue = $page.find('.grfq-continue-shopping a');

            $continue
                .text('Weiter einkaufen')
                .attr('href', '/de/collections/all');

            $page.find('#submitRFQForm')
                .text('Absenden');

            $page.find('.grfq-group_name_text')
                .text('Produkt');

            $page.find('.grfq-group_edit-header .grfq-input-group input')
                .val('Produkt');

            // ===== INPUT =====
            $page.find('#name')
                .attr('placeholder', 'Geben Sie Ihren Namen ein');

            $page.find('#email')
                .attr('placeholder', 'Geben Sie Ihre E-Mail-Adresse ein');

            $page.find('#phone__1724926594202')
                .attr('placeholder', 'Telefonnummer');

            $page.find('#message')
                .attr('placeholder', 'Nachricht oder Frage');

            // ===== LABEL =====
            $page.find('label[for="name"]')
                .html('Name <span class="grfq-required-asterisk"> *</span>');

            $page.find('label[for="phone__1724926594202"]')
                .html('Telefon <span class="grfq-required-asterisk"> *</span>');

            // ===== VARIANT =====
            $page.find('.grfq-variant-title[data-key="taille"], .grfq-variant-title[data-key="size"]').each(function () {

                const $el = $(this);

                $el.attr('data-key', 'size');

                $el.find('.grfq-option-key').each(function (index) {

                if (index === 0) {
                    const text = $(this).text().trim().toLowerCase();

                    if (
                    text.includes('taille') ||
                    text.includes('size') ||
                    text.includes('größe')
                    ) {
                    $(this).text('Größe:');
                    }
                }

                });

            });

            $page.find('.grfq-variant-quantity-wrapper label')
                .text('Menge');

            $page.find('.grfq-product-footer .grfq-continue-shopping a')
                .text('Weiter einkaufen');

            // ===== ADD GROUP =====
            $page.find('.grfq-collapsible-title')
                .text('Zusätzliche Informationen');

            $page.find('button.grfq-product-duplicate p')
                .text('Doppelter Artikel');

            $page.find('.grfq-page-products-add-group .grfq-btn-add-group-product span')
                .text('Segmentiertes Angebot erstellen');

            $page.find('.grfq-product-table .sami-empty-items p')
                .text('Diese Produktgruppe ist derzeit leer');

            $page.find(
                '.grfq-product-table .sami-empty-items .grfq-continue-shopping .AddProductGroup'
            ).text('Produkte zur Gruppe hinzufügen');

            $page.find(
                '.grfq-page-products-groups .grfq-product-table .grfq-product-footer .grfq-group_quick_add-search .grfq-group_quick_add-searchField .grfq-group_quick_add-searchField__Input'
            ).attr(
                'placeholder',
                'Produkt zum Hinzufügen suchen'
            );

        }

        // =====================================================
        // FRENCH
        // =====================================================
        else {

            setTimeout(function () {

                $page.find('.grfq-collapsible-title')
                .text('Infos supplémentaires');

                $page.find('button.grfq-product-duplicate p')
                .text('Article en double');

                $page.find(
                '.grfq-page-products-add-group .grfq-btn-add-group-product span'
                ).text('Créer un devis segmenté');

            }, 600);

            // ===== ADD GROUP =====
            $page.find('.grfq-product-table .sami-empty-items p')
                .text('Ce groupe de produits est actuellement vide');

            $page.find(
                '.grfq-product-table .sami-empty-items .grfq-continue-shopping .AddProductGroup'
            ).text('Ajouter des produits au groupe');

            $page.find(
                '.grfq-page-products-groups .grfq-product-table .grfq-product-footer .grfq-group_quick_add-search .grfq-group_quick_add-searchField .grfq-group_quick_add-searchField__Input'
            ).attr(
                'placeholder',
                'Rechercher un produit à ajouter'
            );
        }
    }
});